import { useState, useEffect } from 'react';
import { initAnalytics } from './firebase';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    initAnalytics();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  return (
    <div className="cookie-banner">
      <p className="cookie-text">
        We use analytics cookies to understand how visitors use this site.{' '}
        <a
          className="cookie-link"
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
      </p>
      <div className="cookie-actions">
        <button className="cookie-btn cookie-btn-decline" onClick={decline}>
          Decline
        </button>
        <button className="cookie-btn cookie-btn-accept" onClick={accept}>
          Accept
        </button>
      </div>
    </div>
  );
}
